import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import AdminTicker from "@/pages/admin/AdminTicker";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import PublicLayout from "@/components/PublicLayout";
import AdminLayout from "@/components/AdminLayout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Events from "@/pages/Events";
import News from "@/pages/News";
import FamilyLife from "@/pages/FamilyLife";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import UsefulContacts from "@/pages/UsefulContacts";
import LegalNotice from "@/pages/LegalNotice";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import MemberSpace from "@/pages/MemberSpace";
import CookieConsent from "@/components/CookieConsent";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminMembers from "@/pages/admin/AdminMembers";
import AdminVolunteers from "@/pages/admin/AdminVolunteers";
import AdminContent from "@/pages/admin/AdminContent";
import AdminFiles from "@/pages/admin/AdminFiles";
import AdminTreasury from "@/pages/admin/AdminTreasury";
import AdminMessages from "@/pages/admin/AdminMessages";
import AdminRsvps from "@/pages/admin/AdminRsvps";
import AdminActivity from "@/pages/admin/AdminActivity";
import AdminListeCetf from "@/pages/admin/AdminListeCetf";
import AdminStore from "@/pages/admin/AdminStore";
import Store from "@/pages/Store";
import ListeCetf from "@/pages/ListeCetf";
import ListeCetfSpace from "@/pages/ListeCetfSpace";
import { getTheme } from "@/utils/theme";

function Protected({ children, admin = false }) {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="loading-screen">
        <div className="animate-spin h-8 w-8 border-4 border-sky-700 border-t-transparent rounded-full" aria-label="Chargement" />
      </div>
    );
  }
  if (!user) return <Navigate to="/connexion" replace />;
  if (admin && !["admin", "super_admin"].includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function App() {
  const [toasterTheme, setToasterTheme] = useState(getTheme());
  useEffect(() => {
    const onTheme = (e) => setToasterTheme(e.detail);
    window.addEventListener("cetf:theme", onTheme);
    return () => window.removeEventListener("cetf:theme", onTheme);
  }, []);

  useEffect(() => {
    document.title = "Cœur d'École Toury Famille — Association conviviale et solidaire à Toury";
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/qui-sommes-nous" element={<About />} />
              <Route path="/evenements" element={<Events />} />
              <Route path="/actualites" element={<News />} />
              <Route path="/vie-des-familles" element={<FamilyLife />} />
              <Route path="/adresses-utiles" element={<UsefulContacts />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/boutique" element={<Store />} />
              <Route path="/liste-cetf" element={<ListeCetf />} />
              <Route path="/mentions-legales" element={<LegalNotice />} />
              <Route path="/politique-confidentialite" element={<PrivacyPolicy />} />
              <Route path="/connexion" element={<Login />} />
              <Route path="/connexion-bureau" element={<Login bureau />} />
              <Route path="/mot-de-passe-oublie" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/espace" element={<Protected><MemberSpace /></Protected>} />
              <Route path="/liste-cetf/espace" element={<Protected><ListeCetfSpace /></Protected>} />
            </Route>
            <Route path="/admin" element={<Protected admin><AdminLayout /></Protected>}>
              <Route index element={<AdminDashboard />} />
              <Route path="membres" element={<AdminMembers />} />
              <Route path="benevoles" element={<AdminVolunteers />} />
              <Route path="contenus" element={<AdminContent />} />
              <Route path="documents" element={<AdminFiles />} />
              <Route path="tresorerie" element={<AdminTreasury />} />
              <Route path="participations" element={<AdminRsvps />} />
              <Route path="messages" element={<AdminMessages />} />
              <Route path="journal" element={<AdminActivity />} />
            <Route path="fil-actualite" element={<AdminTicker />} />
              <Route path="liste-cetf" element={<AdminListeCetf />} />
              <Route path="store" element={<AdminStore />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors theme={toasterTheme} position="top-center" />
        <CookieConsent />
      </AuthProvider>
    </div>
  );
}

export default App;
